import React from "react";
import HeaderHome from "../headers/headerHome";
import Footer from "../components/Footer";

export default function LegalNotice() {
  return (
    <>
      <HeaderHome/>
      <div className="container py-5">

        <h1 className="mb-4">Mentions légales</h1>

        <section className="mb-5">
          <h3>Éditeur du site</h3>
          <p>
            <strong>Nom de l’association :</strong> Association LSR47<br />
            <strong>Adresse :</strong> MVA 54 rue Coquard, 47200 Villeneuve-sur-Lot<br />
            <strong>Email :</strong> mfc1.bournazel@orange.fr<br />
            <strong>Responsable de publication :</strong> Françoise Bournazel<br />
            <strong>Site développé par : </strong>LORTOLARY Valentin
          </p>
        </section>

        <section className="mb-5">
          <h3>Hébergement</h3>
          <p>
            <strong>Hébergeur :</strong> OVH SAS<br />
            <strong>Adresse :</strong> 2 rue Kellermann, 59100 Roubaix
          </p>
        </section>

        

        <section className="mb-5">
          <h3>Modifications des mentions légales</h3>
          <p>
            Les mentions légales peuvent être modifiées à tout moment afin de rester conformes à la législation en vigueur.
            Toute modification sera publiée sur cette page.
          </p>
        </section>

      </div>
      <Footer/>
    </>
  );
}
